export class ApplicationRangeDto {
  id?: number;
  from: number;
  to: number;
  discountAmount?: number;
  constructor(init?: ApplicationRangeDto) {
    Object.assign(this, init);
  }
}
